export const convertTypeName = (type: string) => {
    if (type === "3P") {
        return "Third Party"
    } else if (type === "SI") {
        return "Inspections"
    } else if (type === "FP") {
        return "New Construction"
    }
}